module.exports = __webpack_public_path__ + "img/securating_logo.cf5d7c88.png";